import { ClientPortfolioDomainEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getPortfolioTitle } from "web_myplann/Portfolio/Components/PortfolioSections/portfolioListItemHelpers";
import { EditPensionForm } from "web_myplann/Portfolio/Pages/PensionEdit/EditPensionForm";
import { PortfolioEditLayout } from "web_myplann/Portfolio/PortfolioShared/PortfolioEditLayout";

export const EditPensionPage = () => {
	const { t } = useResource();

	return (
		<PortfolioEditLayout
			expectedDomain={ClientPortfolioDomainEnum.PensionProducts}
			title={(portfolio) =>
				t(Resources.Portfolio.EditPortfolio.title, {
					type: getPortfolioTitle(portfolio, t),
				})
			}
		>
			{({ portfolio, portfolioId, detailRoute }) => (
				<EditPensionForm
					portfolioId={portfolioId}
					portfolio={portfolio}
					detailRoute={detailRoute}
				/>
			)}
		</PortfolioEditLayout>
	);
};
